import { memo, useState } from "react";
import { useDispatch } from "react-redux";
import { isNil } from "lodash";
import { OUTER, SECTOR, POSTCODE } from "../../../consts/layers";
import { Modal } from "../Modal";
import { RemoveArtificialPostcodeContent } from "./RemoveArtificialPostcodeContent";
import { RemoveArtificialPostcodeActions } from "./RemoveArtificialPostcodeActions";
import {
  setArtificialPostcodeEdit,
  deleteArtificialPostcode,
  deleteArtificialPostcodeLocation,
} from "../../../reducers/depot/thunkActions";
import { setSelectedArtificialPostcode } from "../../../reducers/depot";

export const RemoveArtificialPostcodeModal = memo(
  ({ artificialPostcode, onClose }) => {
    const { level, lat, lng } = artificialPostcode;
    const hasLocation = !isNil(lat) && !isNil(lng);
    const [locationOnly, setLocationOnly] = useState(true);
    const dispatch = useDispatch();
    let title = "Remove Postcode";
    if (level === OUTER) title = "Remove Outer location";
    else if (level === SECTOR) title = "Remove Sector location";

    const onContinue = async () => {
      dispatch(setSelectedArtificialPostcode());
      await dispatch(setArtificialPostcodeEdit({ artificialPostcode }));
      if ((hasLocation && locationOnly) || level !== POSTCODE)
        dispatch(deleteArtificialPostcodeLocation());
      else dispatch(deleteArtificialPostcode());
      onClose();
    };

    return (
      <Modal
        open={true}
        onClose={onClose}
        title={title}
        content={
          <RemoveArtificialPostcodeContent
            hasLocation={hasLocation}
            locationOnly={locationOnly}
            level={level}
            artificialPostcode={artificialPostcode}
            onLocationOnlyChange={setLocationOnly}
          />
        }
        actions={
          <RemoveArtificialPostcodeActions
            level={level}
            hasLocation={hasLocation}
            onCancel={onClose}
            onContinue={onContinue}
          />
        }
        maxWidth={"sm"}
      />
    );
  }
);
